import Handler from "@/core/domain/usecase/handler";

const patchServiceOrderReportIdReportDataRepository = (axios) => async (id, data) => {
    try {
        const response = await axios.patch(`service-order-report/${id}/report-data`, data)
        
        return response.data
    } catch (err) {
        if (err.isAxiosError) {
            throw new Handler().trataErro(err)
        } else {
            throw err
        }
    }
}

export default patchServiceOrderReportIdReportDataRepository